import React from 'react'
import { Redirect } from 'react-router-dom'

const Layout = ({ component: Component, user, requiredSession, isAuth, redirect, isAdminAuthRoute, ...props }) => {
    // console.log("user", user)
    const { role, user: userData, isLogged } = user
    // console.log('redirect', requiredSession, isLogged, isAuth, redirect, role)

    if(isAuth) return isLogged ? <Redirect to={{ pathname: redirect }} /> : <Component { ...props } {...{ role, user: userData, isAdminAuthRoute }} />
    if(requiredSession){
        return isLogged? <Component { ...props } {...{ role, user: userData, isAdminAuthRoute }} /> : <Redirect to={{ pathname: redirect }} /> 
    }
    return <Component {...props} {...{ role, user: userData, isAdminAuthRoute }} />
}

export default Layout
